import React from 'react';
import { connect } from "react-redux";
import Styled from 'styled-components'
import { getCompareFields } from './helper';
import { camelCaseToTitle } from '../../../helpers/StringHelper';

const Styles = Styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
  align-items: space-between;
  overflow: scroll;
  ::-webkit-scrollbar {
    display: none;
  }
  .labels {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 12px;
    h3 {
      font-size: var(--font-size-lg);
      width: 50%;
      margin: 0;
    }
  }
  h4 {
    font-size: 14px;
    padding: 8px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    font-weight: 500;
    background: #f3f3f3;
    margin: 0;
  }
  .dataComp {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    p {
      font-size: 14px;
      padding: 8px;
      width: 50%;
      margin: 0;
      border-right: 1px solid rgba(0, 0, 0, 0.1);
      &:nth-of-type(1) {
        border-left: 1px solid rgba(0, 0, 0, 0.1);
      }
    }
  }
  .dataComp.conflict {
    p {
      &:nth-of-type(1) {
        background: rgba(0, 255, 0, 0.1);
      }
      &:nth-of-type(2) {
        text-decoration: line-through;
        background: rgba(255, 0, 0, 0.1);
      }
    }
  }
`;

function Compare({
  entity,
  form,
  oldData,
  newData,
  onAccept = () => { },
  onDecline = () => { },
  isCreate = false,
}) {
  const columns = getCompareFields(entity);
  return <Styles>
    {!isCreate ? <React.Fragment>
      <div className="labels">
        <h3>New Data</h3>
        <h3>Existing Data</h3>
      </div>
      {columns.map(col => (
        <>
          {newData[col] || oldData[col] ? <h4>{camelCaseToTitle(col)}</h4> : null}
          {newData[col] || oldData[col] ?
            <div className={newData[col] !== oldData[col] ? 'conflict dataComp' : 'dataComp'}>
              <p>{newData[col]}</p>
              <p>{oldData[col]}</p>
            </div> : null}
        </>
      ))}
    </React.Fragment> : <div>
      This entity exists.
    </div>}
  </Styles>
}

export default connect()(Compare);
